import { returnDecimalFormatting } from "@/lib/globalFormatterHelper";

// LQC-2909 - the coupon reads as it does inside the security name ("3.80"). "$" is
// the 2dp decimal type here, not a currency.
export function formatCouponRate(value: any): string {
  if (value == null || value === "") return "";
  return returnDecimalFormatting(Number(value), "$");
}

// Display only. The % never reaches copy/paste, so a spreadsheet gets a number.
export function formatCouponRateWithNotation(value: any): string {
  const formatted = formatCouponRate(value);
  return formatted ? `${formatted}%` : "";
}

// AG Grid valueFormatter, which is what the clipboard reads.
export function couponRateValueFormatter(params: { value: any }): string {
  return formatCouponRate(params.value);
}
